interface IOCRConsumptionCostItem {
  type: string;
  unit: string;
}

interface IOCRConsumptionCost {
  consumption: IOCRConsumptionCostItem;
  cost: IOCRConsumptionCostItem;
}

const getOCRConsumptionCostKeys = (key: string): IOCRConsumptionCost => {
  const result: IOCRConsumptionCost = {
    consumption: {type: '', unit: ''},
    cost: {type: '', unit: ''}
  };
  switch (key) {
    // Fuel Bill
    case 'for_machines': {
      break;
    }
    case 'for_vehicle': {
      break;
    }
    case 'for_refrigerant': {
      break;
    }
    // Electricity Bills
    case 'renewable': {
      result.consumption = {type: 'electricity', unit: 'kWh'};
      result.cost = {type: 'cost', unit: 'kWh'};
      break;
    }
    case 'non_renewable': {
      result.consumption = {type: 'electricity', unit: 'kWh'};
      result.cost = {type: 'cost', unit: 'kWh'};
      break;
    }
    // Procurement Bills
    case 'for_raw_material': {
      break;
    }
    case 'for_capital_goods': {
      break;
    }
    // Service Bills
    case 'upstream_transport': {
      break;
    }
    case 'downstream_transport': {
      break;
    }
    // Business Travel Tickets
    case 'business_travel_tickets': {
      break;
    }
    // Water Bills
    case 'water_bills': {
      break;
    }
  }

  return result;
};

export default getOCRConsumptionCostKeys;
